import {useEffect, useState } from 'react';
import $ from 'jquery';
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';

function TokenAuthSettle({ apiUrl }) {
    const [tokenAuthSettle, setTokenAuthSettle] = useState({
        operation: properties.OPERATIONS.tokenauthsettle,
        timestamp:"",
        transactionid: transidgenerator(),
        vendorid: properties.VENDOR_ID,
        password: properties.PASSWORD,
        method:properties.HTTP_METHOD,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        region: properties.SEL_REGION,
        token: properties.TOKEN,
        address: properties.ADDRESS,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        security:""
    });
    
    const [isDpaFlag, setIsDpaFlag] = useState("false");
    
    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;
    
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setTokenAuthSettle({ ...tokenAuthSettle, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setTokenAuthSettle({ ...tokenAuthSettle, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setTokenAuthSettle({ ...tokenAuthSettle, password: e.target.value });
    }

    function changeDesc(e) {
        setTokenAuthSettle({ ...tokenAuthSettle, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setTokenAuthSettle({ ...tokenAuthSettle, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setTokenAuthSettle({ ...tokenAuthSettle, currency: e.target.value });
    }

    function changeToken(e) {
        isNotNullCheck(e.target.value,"WPG_token");
        setTokenAuthSettle({ ...tokenAuthSettle, token: e.target.value });
    }

    function changeAddr(e) {
        setTokenAuthSettle({ ...tokenAuthSettle, address: e.target.value });
    }

    function changePostCode(e) {
        setTokenAuthSettle({ ...tokenAuthSettle, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setTokenAuthSettle({ ...tokenAuthSettle, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setTokenAuthSettle({ ...tokenAuthSettle, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setTokenAuthSettle({ ...tokenAuthSettle, allowAvsFail: e.target.value });
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }

    function onSubmitTokenAuthSet(e) {
        e.preventDefault();
        isNotNullCheck(tokenAuthSettle.token,"WPG_token");
        isNotNullCheck(tokenAuthSettle.password,"vendorPwd");
        isNotNullCheck(tokenAuthSettle.vendorid,"WPG_vendorID");
        isNotNullCheck(tokenAuthSettle.transactionid,"WPG_transID");
        isNotNullCheck(tokenAuthSettle.value,"WPG_value");
        isNotNullCheck(tokenAuthSettle.region,"WPG_region");
        isNotNullCheck(tokenAuthSettle.currency,"WPG_currency");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(tokenAuthSettle.region === "NoR"){
                setTokenAuthSettle({...tokenAuthSettle, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#tokenauthsettle_timestamp").val(time);
            var digest = md5(time + tokenAuthSettle.vendorid + tokenAuthSettle.transactionid + tokenAuthSettle.method + tokenAuthSettle.description +
                tokenAuthSettle.value + tokenAuthSettle.currency + tokenAuthSettle.region + tokenAuthSettle.token + tokenAuthSettle.address + tokenAuthSettle.postCode +
                tokenAuthSettle.countryCode + tokenAuthSettle.allowAvsFail + tokenAuthSettle.password);
            $("#tokenauthsettle_security").val(digest);
            $("#tokenauthsettleForm").attr('action', apiUrl).submit();
        }
    }
      
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var tokenAuthSettleTemplate = (
        <div className="operation-form">
            <h2>Token Authorise & Settle</h2>
            <form className="form-horizontal" method='post' id='tokenauthsettleForm' onSubmit={onSubmitTokenAuthSet}>
                <input type="hidden" name="WPG_timestamp" id="tokenauthsettle_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="tokenauthsettle_security" value="" />
                <input type="hidden" name="WPG_operation" value={tokenAuthSettle.operation} />
                <input type="hidden" name="WPG_method" value={tokenAuthSettle.method}/>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={tokenAuthSettle.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={tokenAuthSettle.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={tokenAuthSettle.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={tokenAuthSettle.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={tokenAuthSettle.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={tokenAuthSettle.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={tokenAuthSettle.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={tokenAuthSettle.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_address" value={tokenAuthSettle.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_postcode" value={tokenAuthSettle.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_countryCode" value={tokenAuthSettle.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_allowAVSFail" value={tokenAuthSettle.allowAvsFail} onChange={changeAllowAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
    );

    return tokenAuthSettleTemplate;
}

export default TokenAuthSettle;